import React from "react"
import Layout from "../components/layout"
import { injectIntl } from "gatsby-plugin-intl"
import "../includes/faq/faq.sass"
import Banner from "../includes/faq/banner"
import Collapsible from "react-collapsible"
import { defaultIntl, getEmail } from "../utils"

const FAQPage = ({ intl = defaultIntl }) => (
  <Layout intl={intl} page="partner">
    <Banner intl={intl} />
    <div className="faq">
      <div className="container">
        <div className="section">
          <h3>{intl.formatMessage({ id: "faq.general" })}</h3>
          <Collapsible trigger={intl.formatMessage({ id: "faq.1.title" })} openedClassName="opend">
            <p>
              <pre>{intl.formatMessage({ id: "faq.1.desc" })}</pre>
            </p>
          </Collapsible>
          <Collapsible trigger={intl.formatMessage({ id: "faq.2.title" })} openedClassName="opend">
            <p>
              <pre>{intl.formatMessage({ id: "faq.2.desc" })}</pre>
            </p>
          </Collapsible>
          <Collapsible trigger={intl.formatMessage({ id: "faq.3.title" })} openedClassName="opend">
            <p>
              <pre>{intl.formatMessage({ id: "faq.3.desc" })}</pre>
            </p>
          </Collapsible>
          <Collapsible trigger={intl.formatMessage({ id: "faq.4.title" })} openedClassName="opend">
            <p>
              <pre>{intl.formatMessage({ id: "faq.4.desc" })}</pre>
            </p>
          </Collapsible>
          <Collapsible trigger={intl.formatMessage({ id: "faq.5.title" })} openedClassName="opend">
            <p>
              <pre>{intl.formatMessage({ id: "faq.5.desc" })}</pre>
            </p>
          </Collapsible>
          <Collapsible trigger={intl.formatMessage({ id: "faq.51.title" })} openedClassName="opend">
            <p>
              <pre>{intl.formatMessage({ id: "faq.51.desc" })}</pre>
            </p>
          </Collapsible>
        </div>
        <div className="section">
          <h3>{intl.formatMessage({ id: "faq.account" })}</h3>
          <Collapsible trigger={intl.formatMessage({ id: "faq.6.title" })} openedClassName="opend">
            <p>
              <pre>{intl.formatMessage({ id: "faq.6.desc" })}</pre>
            </p>
          </Collapsible>
          <Collapsible trigger={intl.formatMessage({ id: "faq.7.title" })} openedClassName="opend">
            <p>
              <pre>{intl.formatMessage({ id: "faq.7.desc" })}</pre>
            </p>
          </Collapsible>
          <Collapsible trigger={intl.formatMessage({ id: "faq.8.title" })} openedClassName="opend">
            <p>
              <pre>{intl.formatMessage({ id: "faq.8.desc" })}</pre>
            </p>
          </Collapsible>
          <Collapsible trigger={intl.formatMessage({ id: "faq.9.title" })} openedClassName="opend">
            <p>
              <pre>{intl.formatMessage({ id: "faq.9.desc" })}</pre>
            </p>
          </Collapsible>
          <Collapsible trigger={intl.formatMessage({ id: "faq.91.title" })} openedClassName="opend">
            <p>
              <pre>{intl.formatMessage({ id: "faq.91.desc" }, { email: getEmail() })}</pre>
            </p>
          </Collapsible>
        </div>
        <div className="section">
          <h3>{intl.formatMessage({ id: "faq.refunds" })}</h3>
          <Collapsible trigger={intl.formatMessage({ id: "faq.10.title" })} openedClassName="opend">
            <p>
              <pre>{intl.formatMessage({ id: "faq.10.desc" })}</pre>
            </p>
          </Collapsible>
          <Collapsible trigger={intl.formatMessage({ id: "faq.11.title" })} openedClassName="opend">
            <p>
              <pre>{intl.formatMessage({ id: "faq.11.desc" })}</pre>
            </p>
          </Collapsible>
        </div>
        <div className="section">
          <h3>{intl.formatMessage({ id: "faq.partners" })}</h3>
          <Collapsible trigger={intl.formatMessage({ id: "faq.12.title" })} openedClassName="opend">
            <p>
              <pre>{intl.formatMessage({ id: "faq.12.desc" })}</pre>
            </p>
          </Collapsible>
          <Collapsible trigger={intl.formatMessage({ id: "faq.13.title" })} openedClassName="opend">
            <p>
              <pre>{intl.formatMessage({ id: "faq.13.desc" })}</pre>
            </p>
          </Collapsible>
          <Collapsible trigger={intl.formatMessage({ id: "faq.14.title" })} openedClassName="opend">
            <p>
              <pre>{intl.formatMessage({ id: "faq.14.desc" })}</pre>
            </p>
          </Collapsible>
          <Collapsible trigger={intl.formatMessage({ id: "faq.141.title" })} openedClassName="opend">
            <p>
              <pre>{intl.formatMessage({ id: "faq.141.desc" })}</pre>
            </p>
          </Collapsible>
        </div>
        <div className="section">
          <h3>{intl.formatMessage({ id: "faq.payment" })}</h3>
          <Collapsible trigger={intl.formatMessage({ id: "faq.15.title" })} openedClassName="opend">
            <p>
              <pre>{intl.formatMessage({ id: "faq.15.desc" })}</pre>
            </p>
          </Collapsible>
          <Collapsible trigger={intl.formatMessage({ id: "faq.16.title" })} openedClassName="opend">
            <p>
              <pre>{intl.formatMessage({ id: "faq.16.desc" })}</pre>
            </p>
          </Collapsible>
        </div>
        {/* <div className="section">
          <h3>{intl.formatMessage({ id: "faq.membership" })}</h3>
          <Collapsible trigger={intl.formatMessage({ id: "faq.17.title" })} openedClassName="opend">
            <p>
              <pre>{intl.formatMessage({ id: "faq.17.desc" })}</pre>
            </p>
          </Collapsible>
          <Collapsible trigger={intl.formatMessage({ id: "faq.18.title" })} openedClassName="opend">
            <p>
              <pre>{intl.formatMessage({ id: "faq.18.desc" })}</pre>
            </p>
          </Collapsible>
        </div> */}
      </div>
    </div>
  </Layout>
)

export default injectIntl(FAQPage)
